import { Page } from '@/components/page';
import { PageEditorWidget } from '@/components/page-editor-widget';
import { Toggle } from '@/components/toggle';
import { CapabilitiesListWidget } from '@/features/capabilities/components/capabilities-list-widget';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';
import { useState } from 'react';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { ContainerListWidget } from '@/features/containers/components/container-list-widget/container-list-widget';
import { ComponentsListWidget } from '@/features/components-studio/components/components-list-widget/components-list-widget';

const layout = [{ i: 'list', x: 0, y: 0, w: 40, h: 25 }];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function PageEditor() {
  const [isDraggable, setIsDraggable] = useState(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page title="Compose Content">
      <ContainerListWidget id={`${idPrefix}/list`} hideable={true} />
      <ComponentsListWidget id={`${idPrefix}/components`} hideable={true} />
      <PageEditorWidget />
    </Page>
  );
}
